import { SiteItemData, SiteVideoData } from "../../../../interfaces";

interface VerticalVideoGalleryBepoItemMutamProps {
    videoItem: SiteItemData & { category: any }
    videoIndex: number
    currentPromoIndex: number
    isPromoCarouselInView: boolean
    onVideoEnded: () => void
    onOpenVideoGalleryView: (e) => void
    pushGA4Event: (action: string, isFeedDisplay: boolean) => void
}

interface VerticalVideoGalleryBepoItemMutamState {
    isVideoReady: boolean
}

export class VerticalVideoGalleryBepoItemMutam extends React.Component<VerticalVideoGalleryBepoItemMutamProps, VerticalVideoGalleryBepoItemMutamState> {
    constructor(props) {
        super(props);
        this.state = {
            isVideoReady: false
        }
    }

    private videoRef;

    componentDidUpdate(prevProps: VerticalVideoGalleryBepoItemMutamProps) {
        const { videoIndex, currentPromoIndex } = this.props;

        if (currentPromoIndex !== prevProps.currentPromoIndex && currentPromoIndex === videoIndex) {
            if (this.videoRef) {
                const videoElement = document.getElementById(`verticalVideoGalleryBepoItem_${videoIndex}`);
                const videoRect = videoElement.getBoundingClientRect();
                const containerElement = document.querySelector(".verticalVideoGalleryBepoComponentMutam .frame_forList");
                const containerRect = containerElement.getBoundingClientRect();


                if (videoRect.left < containerRect.left || videoRect.right > containerRect.right) {
                    const scrollElement = document.querySelector(".verticalVideoGalleryBepoComponentMutam .slotListWrapper");
                    scrollElement.scrollBy({ behavior: 'smooth', left: videoRect.left - containerRect.left - 15 });
                }
            }
        }
    }

    private handleVideoCanPlay = () => {
        this.setState({ isVideoReady: true });
    };

    private secondsToMinutesHandler = (seconds: number) => {
        const minutes = Math.floor(seconds / 60).toString().padStart(2, "0");
        const newSeconds = (seconds % 60).toString().padStart(2, "0");
        return `${minutes}:${newSeconds}`;
    }

    private onVideoError = () => {
        console.error("Video failed to load");
        this.props.onVideoEnded();
    }

    public render() {
        const { isVideoReady } = this.state;
        const { videoItem, onOpenVideoGalleryView, videoIndex, onVideoEnded, currentPromoIndex, isPromoCarouselInView } = this.props;
        const { media, title, category } = videoItem;
        const { duration, poster, promoPath } = media as SiteVideoData;
        const shouldDisplayPromo = isPromoCarouselInView && promoPath && currentPromoIndex === videoIndex;
        const slotClasses = `slotView ${shouldDisplayPromo ? "active" : ""}`;
        const categoryText = category && category.textToShow;
        const categoryImage = category && category.categoryIcon ? category.categoryIcon : null;

        return (
            <div className={slotClasses} id={`verticalVideoGalleryBepoItem_${videoIndex}`} onClick={() => onOpenVideoGalleryView(videoIndex)}>
                <div className="mediaWrapper">
                    {shouldDisplayPromo &&
                        <video
                            muted
                            playsInline
                            loop={false}
                            autoPlay={true}
                            poster={poster}
                            src={promoPath}
                            webkit-playsInline
                            className="promoVideo"
                            onEnded={onVideoEnded}
                            onError={this.onVideoError}
                            ref={ref => this.videoRef = ref}
                            onCanPlay={this.handleVideoCanPlay}
                        >
                        </video>
                    }

                    <img className={`poster ${isVideoReady ? "fade-out" : "fade-in"}`} src={poster} alt="" />
                </div>

                <div className="contentDiv">
                    {categoryImage && <img width={32} height={32} src={categoryImage} alt={categoryText} />}

                    {categoryText && <div className="categoryName">{categoryText}</div>}

                    {/* <div className="videoDuration">
                        <span>{this.secondsToMinutesHandler(Math.round(duration))}</span>
                        <span className="durationLogo"></span>
                    </div> */}
                </div>
            </div>
        )
    }
}

